export default "__VITE_ASSET__CiYpvxIN__"